const InvestmentHyfye = () => {
  return (
    <section className="bg-animated bg-animated bg-12">
      <div className="container ">
        <div className="row align-items-center">

          {/* Left Side - Text Content */}
          <div className="col-lg-6 col-md-12 col-sm-12">
            <div className="title_dark title_border">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Invest in the Infrastructure of the Web3 Future
              </h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Hyfye is not just another token—it's a foundational layer for decentralized tools, digital utilities, and borderless innovation. 
                Our mission is to enable real-world and digital access through a single, powerful token ecosystem.
                <br /><br />
                By investing in Hyfye, you're backing a platform that delivers scalable blockchain infrastructure, token-powered utilities, and meaningful digital transformation for businesses and users alike.
              </p>
            </div>

            {/* Updated Features List */}
            <ul className="list_info list_info_half list_none">
              <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="list_icon"><i className="fa fa-users"></i></div>
                <div className="list_content">
                  <h6>Community-Centric Ecosystem</h6>
                </div>
              </li>
              <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="list_icon"><i className="fa fa-cogs"></i></div>
                <div className="list_content">
                  <h6>Real-World & Digital Utilities</h6>
                </div>
              </li>
              <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="list_icon"><i className="fa fa-mobile"></i></div>
                <div className="list_content">
                  <h6>Cross-Platform Accessibility</h6>
                </div>
              </li>
              <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="list_icon"><i className="fa fa-globe"></i></div>
                <div className="list_content">
                  <h6>Borderless Digital Infrastructure</h6>
                </div>
              </li>
              <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="list_icon"><i className="fa fa-rocket"></i></div>
                <div className="list_content">
                  <h6>Optimized for Scale & Speed</h6>
                </div>
              </li>
              <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="list_icon"><i className="fa fa-leaf"></i></div>
                <div className="list_content">
                  <h6>Green & Efficient Blockchain</h6>
                </div>
              </li>
            </ul>
          </div>

          {/* Right Side - Image */}
          <div className="col-lg-6 col-md-12 col-sm-12">
            <div className="text-center res_md_mt_50 res_sm_mt_20">
             
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default InvestmentHyfye;
